/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';
import { IListRegionReturn } from '../interfaces/region';
import { RegionStatusManager } from '../services/manager';
import { getAllRegions } from '../services/region';
import { listRegionActions } from './definition';


const regionListReset = () => {
    return {
        type: listRegionActions.LIST_REGION_RESET,
    };
};

// Recuders of Region Collection
function regionIsLoadingList() {
    return {
        type: listRegionActions.LIST_REGION_IS_LOADING,
    };
}

function regionErrorList(e: string) {
    return {
        type: listRegionActions.LIST_REGION_ERROR,
        error: e,
    };
}

function regionSetList(regions: any) {
    return {
        type: listRegionActions.LIST_REGION,
        data: regions,
    };
}

/**
 * Reducer to rest a regions
 * @param values Data to reset regions
 */
export const resetStateRegion = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(regionListReset());
    };
};

/**
 * Reducer to rest a regions
 * @param values Data to reset regions
 */
export const resetRegionReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(regionListReset());
    };
};

/**
 * Reducer to reset Regions
 * @param values Values to reset regions
 */
export const resetRegion = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(regionListReset());
    };
};

// List

/**
 * Reducer to get all the regions
 */
export const fetchListRegions = (query: any  ) => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(regionIsLoadingList());
        await getAllRegions(query)
            .then((response: IListRegionReturn) => {
                if (response.statusCode === RegionStatusManager.REGIONS_LISTED) {
                    dispatch(regionSetList(response.data));
                } else {
                    dispatch(regionErrorList(response.message));
                }
            })
            .catch((error) => {
                dispatch(regionErrorList(error));
            });
    };
};
